/* eslint-disable max-len, react/prop-types */
const Icon = ({ className = '' }) => (
  <svg className={className} width="36" height="36" viewBox="0 0 48 48">
    <title>Google Calendar</title>
    <path
      d="m9 22c0-1.4.2-2.8.7-4.1l-7.4-5.7c-1.5 3-2.3 6.3-2.3 9.8s.8 6.8 2.3 9.7l7.4-5.7c-.5-1.2-.7-2.6-.7-4z"
      fill="#fbbc05"
    />
    <path
      d="m22 9c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4c-3.9-3.4-8.9-5.5-14.5-5.5-8.7 0-16.2 5-19.7 12.3l7.4 5.7c1.7-5.3 6.5-9 12.3-9z"
      fill="#ea4335"
    />
    <path
      d="m22 35c-5.8 0-10.6-3.7-12.3-8.9l-7.4 5.7c3.5 7.2 11 12.2 19.7 12.2 5.4 0 10.5-1.9 14.3-5.5l-7-5.4c-2 1.2-4.5 1.9-7.3 1.9z"
      fill="#34a853"
    />
    <path d="m22 18v8.5h11.8c-.6 2.9-2.2 5.1-4.5 6.6l7 5.4c4-3.8 6.7-9.3 6.7-16.5 0-1.3-.2-2.7-.5-4z" fill="#4285f4" />
  </svg>
);
export default Icon;
